import styles from "./Review.module.css"
import { useCallback, useEffect, useState } from "react";
import Loading from "../common/Loading";
import { reviewLessonWords, completeReviewApi } from "../../resources/api";
import { playSound } from "../../utils/playsound";
import Button from "../common/Button";
// import { LessonTitles } from "../../const/lessonTitles";
import { LessonTitles } from "../../const/lessonTitles2";
import Type1 from "./Type1";
import FloatingObject from "../common/FloatingObjects";
import { soundLessons } from "../../const/lessons";




export default function Review({ lessonId, percentage, lessonDetails, trialId, openExtras, onNext, computerResults }) {
    const [page, setPage] = useState("loading")
    const [buttonsDisabled, setButtonsDisabled] = useState(true)
    const [reviewType, setReviewType] = useState(null)

    const [reviewData, setReviewData] = useState([])
    const [reviewTrialId, setReviewTrialId] = useState(null)

    // Item selection + statefulness now live server-side (GET /student/review,
    // backed by process/review/reviewModule). A lesson that returns review items
    // shows the card grid (Type1); otherwise fall back to the old revision replay.
    const loadingCb = useCallback(async () => {
        let items = [], rtid = null
        try {
            const res = await reviewLessonWords(lessonId, trialId)
            items = res.data?.items || []
            rtid = res.data?.reviewTrialId || null
        } catch (e) {
            items = []
        }
        setReviewData(items)
        setReviewTrialId(rtid)
        setReviewType(items.length > 0 ? "correction" : "revision")
        setPage("intro")
        await playSound(`review/reviewlesson`)
        setButtonsDisabled(false)
    }, [lessonId, trialId])

    // Mark the review complete server-side; this is what opens the retake gate.
    const completeReview = useCallback(async () => {
        try {
            if (reviewTrialId) await completeReviewApi(reviewTrialId)
        } catch (e) {
            /* non-fatal: the /start gate will re-issue the review if needed */
        }
    }, [reviewTrialId])

    useEffect(() => {
        setPage("loading")
        loadingCb().catch(alert)
    }, [lessonId]);


    return <>
        {
            (page === "loading") ? <Loading /> : <div className={styles.reviewContainer}>
                {
                    page == "intro" && <>
                        {
                            typeof percentage == "number" && <h1 style={{ fontSize: 67, marginBottom: 20 }}>{Math.floor(percentage * 100)}%</h1>
                        }
                        <h1 className={styles.reviewTitle}>Review Lesson</h1>
                        <h1 className={styles.lessonTitle}>{LessonTitles[lessonId].title}</h1>
                        <Button isDisabled={buttonsDisabled} onClick={async () => {
                            setButtonsDisabled(true)

                            if (reviewType === "correction") {
                                setPage(reviewType)
                                await playSound("review/review")
                            } else if (lessonDetails?.review) {
                                var oLid = lessonDetails.review.fromLesson
                                if (oLid === "self") {
                                    oLid = lessonId;
                                }
                                //await playSound("review/review2")
                                openExtras(oLid, lessonDetails.review.stages)
                            } else {
                                // nothing to review for this lesson — just continue
                                onNext()
                            }
                            setButtonsDisabled(false)
                        }
                        } paddingV="full" paddingH="full" title={"Review Lesson"} icon={"right"} background={"green"} click={"inside"} />
                    </>
                }

                {
                    page == "correction" && <Type1 status={computerResults.status} controls={computerResults?.controls} buttonsDisabled={buttonsDisabled} items={reviewData} reviewTrialId={reviewTrialId} trialId={trialId} lessonId={lessonId} onComplete={completeReview} onNext={() => onNext()} />
                }

                {/*{*/}
                {/*    page == "type3" && <Type3 buttonsDisabled={buttonsDisabled} lessonId={lessonId} trialId={trialId} onNext={()=>onNext()}/>*/}
                {/*}*/}
                {/*{*/}
                {/*    page == "type4" && <Type4 buttonsDisabled={buttonsDisabled} lessonId={lessonId} trialId={trialId} onNext={()=>onNext()}/>*/}
                {/*}*/}
            </div>
        }
        <FloatingObject color={"rgba(78,84,200, 0.2)"} />
    </>
}